import EditorialDefault from "../components/Editorial/Default";
import CompleteSubmissions from "../components/Editorial/CompleteSubmissions";
import IncompleteSubmissions from "../components/Editorial/IncompleteSubmissions";
import ManuscriptDetails from "../components/Editorial/ManuscriptDetails";
import EditorAssignedManuscripts from "../components/Editorial/EditorAssignedManuscripts";

import Reviews from "../components/Review/Reviews";
import Communications from "../components/Communication/Communications";

const routes = [
  {
    path: "/editorial",
    component: EditorialDefault,
    redirect: "/editorial/complete",
    meta: {
      requiresAuth: true,
      section: "Editorial",
    },
    children: [
      {
        path: "assigned",
        name: "assignedManuscripts",
        component: EditorAssignedManuscripts,
        meta: {
          requiresAuth: true,
          description: "Editorial: Manuscripts assigned to you as editor",
        },
      },
      {
        path: "incomplete",
        name: "incompleteSubmissionsList",
        component: IncompleteSubmissions,
        meta: {
          requiresAuth: true,
          description: "Editorial: Incomplete submissions",
        },
      },
      {
        path: "complete",
        name: "completeSubmissionsList",
        component: CompleteSubmissions,
        meta: {
          requiresAuth: true,
          description: "Editorial: Complete submissions",
        },
      },
      {
        props: true,
        path: "complete/:manuscriptId",
        alias: ["incomplete/:manuscriptId", "assigned/:manuscriptId"],
        name: "editorialManuscriptDetails",
        component: ManuscriptDetails,
        meta: {
          requiresAuth: true,
          description: "Editorial: Manuscript details",
        },
      },
      {
        path: "communications",
        name: "communications",
        component: Communications,
        meta: {
          requiresAuth: true,
          description: "Editorial: Communications received",
        },
      },
      {
        path: "reviews",
        name: "reviews",
        component: Reviews,
        meta: {
          requiresAuth: true,
          description: "Editorial: Manuscript reviews",
        },
      },
    ],
  },
];

export default routes;
